var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalEvents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_787_5087)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0012 5.73413C17.2593 5.73413 11.793 11.2005 11.793 17.9423C11.793 24.6842 17.2593 30.1507 24.0012 30.1507C30.7431 30.1507 36.2094 24.6843 36.2094 17.9424C36.2094 11.2006 30.7431 5.73413 24.0012 5.73413Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0012 10.8098L21.7371 15.0697L16.9883 15.9068L20.3393 19.3747L19.667 24.1502L24.0012 22.0348L28.3355 24.1502L27.6632 19.3747L31.0142 15.9068L26.2654 15.0697L24.0012 10.8098Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0009 42.42L19.462 34.3334C12.2737 32.3483 6.99609 25.7632 6.99609 17.9423C6.99609 8.55103 14.6096 0.9375 24.0009 0.9375C33.3923 0.9375 41.0058 8.55103 41.0058 17.9423C41.0058 25.7632 35.7281 32.3482 28.5398 34.3334L24.0009 42.42Z",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6078 37.7773H37.2295L40.6443 47.0624H7.35742L10.7722 37.7773H21.394",
    stroke: "#1A1E18",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_787_5087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalEvents);
export default __webpack_public_path__ + "static/media/local-events.f9d0a04386dc56a943ce3f9e4697fb01.svg";
export { ForwardRef as ReactComponent };